export const Notes = {
  // バリデーションエラーのTooltip用
  specialChar: '@ # $ % ^ & * - _ ! + = [ ] { } | \\ : \' , . ? / ` ~ " ( ) ;',
} as const
